'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
const Breadcrumb = forwardRef(({ ...props }, ref) => _jsx("nav", { ref: ref, "aria-label": "breadcrumb", ...props }));
Breadcrumb.displayName = 'Breadcrumb';
export { Breadcrumb };
